// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__stratco/index.scss
// module id = /tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!/tool/node_modules/css-loader/index.js??ref--10-1!/tool/node_modules/postcss-loader/lib/index.js??ref--10-2!/tool/node_modules/sass-loader/lib/loader.js??ref--10-3!/tool/project/client/src/site__stratco/index.scss
// module chunks = site__stratco